function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCatarina(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 236.745,
    height: 296.241,
    viewBox: "0 0 62.639 78.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M410.443 379.173c-5.043-3.467-11.031-.701-15.21 2.814-3.619-4.868-9.349-8.393-15.513-9.511.315-8.3-2.465-19.39-12.733-16.076-2.362.762-1.352 4.495 1.028 3.727 6.922-2.235 8.213 6.17 7.929 11.976-6.757-.11-13.622 2.819-18.493 10.125l39.426 20.1c3.141-6.072 2.818-12.03.375-17.03.073-.049.146-.094.218-.157 2.761-2.441 6.902-5.023 10.572-2.941 3.816 2.166 2.16 8.018.887 11.109-.949 2.305 2.791 3.3 3.728 1.028 1.988-4.835 2.747-11.754-2.214-15.164",
    style: {
      fill: "#401f0d"
    },
    transform: "translate(-205.28 -223.198)scale(.64295)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.274 388.314c-39.108-35.782-92.225 37.389-46.456 64.818 24.622 14.752 51.763-6.899 56.825-31.369 2.425-11.718-1.512-25.345-10.369-33.449",
    style: {
      fill: "#ed1c24"
    },
    transform: "translate(-205.28 -223.198)scale(.64295)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.368 387.354c-19.373-12.684-57.053 23.221-31.889 45.814 19.957 17.913 45.691-8.767 41.008-30.423-1.676-7.752-4.981-12.681-9.119-15.391",
    style: {
      fill: "#ff1526"
    },
    transform: "translate(-205.28 -223.198)scale(.64295)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.174 415.855a5.798 5.798 0 1 1-11.596 0 5.798 5.798 0 0 1 11.596 0m30.536 8.118a8.117 8.117 0 1 1-16.235-.003 8.117 8.117 0 0 1 16.235.003m14.687-10.824a6.57 6.57 0 1 1-13.14 0 6.57 6.57 0 0 1 13.14 0m-35.946-16.233a6.957 6.957 0 1 1-13.914 0 6.958 6.958 0 0 1 13.914 0m19.327 49.861a5.025 5.025 0 1 1-10.05-.002 5.025 5.025 0 0 1 10.05.002m-7.513-60.685a4.084 4.084 0 0 1-8.166 0 4.083 4.083 0 0 1 8.166 0",
    style: {
      fill: "#401f0d"
    },
    transform: "translate(-205.28 -223.198)scale(.64295)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.735 383.774s-1.547-1.546-1.548-1.545c-24.736 13.141-24.764 47.779-48.701 63.39 9.211 9.978 23.757 12.335 23.962 12.368-1.098-.176-3.103-13.049-3.191-14.464-1.181-19.058 15.199-47.314 29.478-59.749",
    style: {
      fill: "#401f0d"
    },
    transform: "translate(-205.28 -223.198)scale(.64295)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatarina);
export default __webpack_public_path__ + "static/media/catarina.e163f4d90f7509a7bc3254c942d4f073.svg";
export { ForwardRef as ReactComponent };